import { Link, useLocation } from "react-router-dom";
import { styles } from "../styles";
import { useShop } from "../context/ShopContext";

// The pawprint mark from the prototype, shown when no logo is uploaded.
function PawMark() {
  return (
    <span style={styles.mark} aria-hidden="true">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
        <circle cx="7" cy="8" r="2.1" fill="currentColor" />
        <circle cx="12" cy="6.4" r="2.1" fill="currentColor" />
        <circle cx="17" cy="8" r="2.1" fill="currentColor" />
        <path
          d="M12 11c-3 0-5 2.2-5 4.6 0 1.7 1.4 2.6 3 2.2 1.3-.3 2.7-.3 4 0 1.6.4 3-.5 3-2.2C17 13.2 15 11 12 11z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}

export function Header() {
  const { config } = useShop();
  const { pathname } = useLocation();
  const onAdmin = pathname.startsWith("/admin");

  return (
    <header style={styles.header}>
      <Link to="/" style={styles.brand} aria-label={`${config.shopName || "Radiance"} home`}>
        {config.logoUrl ? (
          <img src={config.logoUrl} alt="" style={styles.logoImg} />
        ) : (
          <PawMark />
        )}
        <span style={styles.brandName}>{config.shopName || "Radiance"}</span>
        <span style={styles.brandSub}>Professional Dog Grooming</span>
      </Link>
      <nav style={styles.nav} aria-label="Main">
        <div style={styles.segmented} role="tablist" aria-label="Switch view">
          <Link
            to="/" role="tab" className="seg" aria-selected={!onAdmin}
            style={{ ...styles.seg, ...(!onAdmin ? styles.segOn : {}) }}
          >
            Book
          </Link>
          <Link
            to="/admin" role="tab" className="seg" aria-selected={onAdmin}
            style={{ ...styles.seg, ...(onAdmin ? styles.segOn : {}) }}
          >
            Admin
          </Link>
        </div>
      </nav>
    </header>
  );
}
